// 获取区域管理信息
import request from '@/util/request';

// 根据id 查询具体对象信息 （中国44）
export function searchArea (id) {
	return request({
		url: `/region-s/area/searchAreaById/${id}`,
		method: 'get',
		params: {lan: stage.languageId}
	});
}

// 根据level 查询所有列表信息 level (1,2,3,4,5,6)
export function searchAreaListByLevel (level) {
	return request({
		url: `/weather-s/area/searchAreaListByLevel/${level}`,
		method: 'get',
		params: {lan: stage.languageId}
	});
}

// 根据上级id查询下级列表
export function searchAreaList (id) {
	return request({
		url: `/weather-s/area/searchAreaListByPid/${id}`,
		method: 'get',
		params: {lan: stage.languageId}
	});
}

// 根据经纬度获取地址
export function apiLngLatToLocation (data) { // {longitude:number,latitude:number}
	let parms = data;
	parms.lan = stage.languageId;
	return request({
		url: `/region-s/location/searchdetails`,
		method: 'get',
		params: parms
	});
}

// 根据经纬度查询区域信息列表（层级明细信息）
export function searchAreaDetailsByLatlon (data) { // {longitude:number,latitude:number}
	return request({
		url: `/region-s/area/searchAreaDetailsByLatlon`,
		method: 'get',
		params: data
	});
}

// 语言，只有中文和非中文区别（区别只在于CNY显示为元），空或其他默认为en
export function dictListCurrency (params) {
	return request({
		url: `/region-s/dict/listCurrency`,
		method: 'get',
		params
	});
}

// 时区列表
export function dictListTimezone (params) {
	return request({
		url: `/region-s/dict/listTimezone`,
		method: 'get',
		params
	});
}
// 全时区偏移量
export function apiGetTimezoneOffset () {
	return request({
		url: `/region-s/dict/listTimezone/all`,
		method: 'get'
	});
}

// 天气-地址位置
export function weatherAddress (data) {
	return request({
		url: `/region-s/location/search`,
		method: 'get',
		params: data
	});
}
// 气象查询
// export function weatherState(data) {
// 	return request({
// 		url: `/region-s/weather/search`,
// 		method: 'get',
// 		params: data
// 	})
// }
export function weatherState (data) {
	return request({
		url: `/weather-s/weather/searchForecast`,
		method: 'get',
		params: data
	});
}

export function apiMonthAvgByNASA (data) { // nasa月平均辐照,data:{lat:number,lon:number}
	data = $.extend({
		request: 'execute',
		identifier: 'SinglePoint',
		parameters: 'ALLSKY_SFC_SW_DWN',
		userCommunity: 'SSE',
		tempAverage: 'CLIMATOLOGY',
		outputList: 'JSON,ASCII',
		user: 'anonymous'
	}, data);
	return request({
		url: `/nasa-s/cgi-bin/v1/DataAccess.py`,
		method: 'get',
		params: data
	});
}

export function apiUmTest (data) {
	return request({
		url: `/umTest`,
		method: 'get'
		// params: data
	});
}

// 获取用户ip
export function apiGetIp () {
	return request({
		url: `http://`,
		method: 'get'
		// params:{ip:ip}
	});
}

// 根据ip获取国家
// export function apiIpGetCountry (ip) {
// 	if (stage.loc.ipCountry) {
// 		return new Promise(resolve => {
// 			resolve(stage.loc.ipCountry);
// 		});
// 	} else {
// 		let getData = request({
// 			url: `/region-s/ip/searchCountryCode`,
// 			method: 'get',
// 			params: {ip: ip}
// 		});
// 		getData.then(success => {
// 			stage.loc.ipCountry = success;
// 		});
// 		return getData;
// 	}
// }
// 直接获取客户端所在国家
export function apiGetCountry () {
	if (stage.loc.ipCountry.code) {
		return new Promise((resolve) => {
			resolve(stage.loc.ipCountry);
		});
	} else {
		let getData = request({
			url: `/region-s/ip/getCountryCode`,
			method: 'get'
		});
		getData.then((success) => {
			stage.loc.ipCountry = success;
		});
		return getData;
	}
}

// 获取手机号码国家前缀
export function apiGetPhonePrefixList () {
	return request({
		url: `/region-s/dict/listPhonePrefix`,
		method: 'get',
		params: {lan: stage.languageId}
	});
}

// 上传文件
export function apiUploadFile (file, fullName) {
	let formData = new FormData();
	formData.append('pathKey', 'temp');
	formData.append('file', file, fullName || '');
	return request({
		url: `/store-s/uploadObject`,
		method: 'post',
		data: formData
	});
}

// 获取公告
export function apiAnnouncement (data) {
	return request({
		url: `/announcement-s/announcement/content`,
		method: 'post',
		data: $.extend(true, {
			lan: stage.languageId,
			channel: 'Web',
			platformCode: stage.loc.platformCode,
			version: stage.verExternal,
			startTime: new Date().getTime()
		}, data)
	});
}

// 提交客户端版本
export function apiUpdateVersion () {
	if (stage.loc.platformName && stage.loc.platformCode) { // 没有平台相关信息不提交，说明不需要
		return request({
			url: `/announcement-s/app/upgrade/add-version`,
			method: 'post',
			data: {
				channel: 'Web',
				innerVersion: Number(stage.ver.split('.').join('')),
				platform: stage.loc.platformName,
				platformCode: stage.loc.platformCode,
				type: 1,
				version: stage.verExternal
			}
		});
	}
}

export function apiGetManual (params) { // 获取说明书文档
	return request({
		url: `/announcement-s/document/getDocList`,
		method: 'get',
		params: {
			channel: 'Web',
			platformCode: stage.loc.platformCode
		}
	});
}



// WEBPACK FOOTER //
// ./src/api/base.js